/**
 * Saving a file the browser already holds.
 *
 * `downloadBlob` hands a Blob (an export the server produced) to the browser's save flow
 * through a short-lived object URL. `downloadCsv` builds a CSV client-side from rows,
 * RFC 4180-quoted, with a UTF-8 BOM so Excel reads accents, and with formula injection
 * neutralised: a cell starting with `= + - @`, a tab or a carriage return is prefixed with
 * `'` (OWASP CSV injection; contract v1.3).
 */
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoked on the next tick: some browsers start the save asynchronously after click().
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

const FORMULA_START = /^[=+\-@\t\r]/;

/** One RFC 4180 cell: quoted when needed, formula starts neutralised; null/undefined → empty. */
export const csvCell = (value) => {
  let s = value === null || value === undefined ? "" : String(value);
  if (FORMULA_START.test(s)) s = `'${s}`;
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** `rows` is an array of arrays; the first is the header. */
export function downloadCsv(rows, filename) {
  const text = rows.map((r) => `${r.map(csvCell).join(",")}\r\n`).join("");
  downloadBlob(new Blob(["﻿", text], { type: "text/csv;charset=utf-8" }), filename);
}

/** "clients-2026-09-29.csv" */
export const datedFilename = (stem, ext, date = new Date()) => `${stem}-${date.toISOString().slice(0, 10)}.${ext}`;
